// Simple file logger for debugging
const logger = {
  log: (message, data = null) => {
    try {
      const timestamp = new Date().toISOString();
      const logEntry = `${timestamp} - ${message}` + 
        (data ? `\n${JSON.stringify(data, null, 2)}` : '') + '\n\n';
      
      // Try to persist logs between page refreshes
      if (!window._debugLogs) window._debugLogs = '';
      window._debugLogs += logEntry;
      
      // Attempt to save to localStorage as fallback
      try {
        const existing = localStorage.getItem('debugLogs') || '';
        localStorage.setItem('debugLogs', existing + logEntry);
      } catch (e) {
        console.error('Failed to save logs to localStorage:', e);
      }
      
      console.log(logEntry.trim());
    } catch (e) {
      console.error('Logger error:', e);
    }
  },
  
  download: () => {
    try {
      const blob = new Blob([window._debugLogs || ''], {type: 'text/plain'});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'frontend.log';
      a.click();
    } catch (e) {
      console.error('Failed to download logs:', e);
    }
  }
};

export default logger;